<div class="col-12">
  <div class="col-6">
    <!--<button pButton type="button" [label]="'COMMON.CLOSE' | translate"
            [icon]="'fa fa-close'" class="p-button-danger"
            (click)="documentClose()"></button>-->
  </div>
  <div class="col-6 align-right">
    <button pButton type="button" [label]="'COMMON.SAVE' | translate"
            [icon]="'fa fa-save'" class="p-button-success"
            (click)="documentSave()"></button>
  </div>
</div>
<div class="col-12">
  <div class="editor-frame-container" [ngClass]="{'col-9': draggableColumns && draggableColumns.length > 0, 'col-12': !draggableColumns || draggableColumns.length < 1}">
    <iframe #inlineFrame id="inlineFrame" width="100%" height="100%" [src]="loolFileUrl | safeObjUrl"></iframe>
  </div>
  <div class="col-3 col-list-container" *ngIf="draggableColumns && draggableColumns.length > 0">
    <p-fieldset [legend]="'UPLOAD_COMPONENT.DRAGABLE_COLS_TITLE' | translate">
      <div class="col-12">
        <i class="fa fa-question-circle col-tool-tip-button" [tooltipPosition]="'left'" [pTooltip]="('UPLOAD_COMPONENT.DRAGABLE_COLS_TOOLTIP' | translate) "></i>
      </div>
      <div class="col-12">
        <ul>
          <li *ngFor="let column of draggableColumns let idx= index">
            <button (click)="copyText(idx)" class="p-button-success copy-col-handler" type="button" [icon]="'fa fa-copy'"
                    [pTooltip]="('UPLOAD_COMPONENT.DRAGABLE_COL_TOOLTIP' | translate) + column" pButton></button>
            <span class="col-list-entry" [id]="'column-' + idx">{{column}}</span>
          </li>
        </ul>
      </div>
    </p-fieldset>
    <!--    <hr>
          <input class="no-border-input" [id]="'column-' + idx" type="text" (mouseenter)="selectAll($event)" (mouseleave)="unselect($event)"
                 *ngFor="let column of draggableColumns let idx= index" [value]="fieldMap['column-' + idx]"
                 (dragstart)="dragStart($event)" draggable="true">-->
  </div>
</div>
